import { Nullable } from '@models/common.model';

/**
 * Convert string | null | undefined to number
 *
 * @export
 * @param {Nullable<string>} value
 * @param {number} defaultValue
 * @return {*}
 */
export function convertStringToNumber(value: Nullable<string>, defaultValue: number) {
    if (value && !isNaN(parseInt(value))) {
        return parseInt(value);
    }
    return defaultValue;
}
